import { getAuth, signInWithCredential, PhoneAuthProvider } from "firebase/auth";
import * as Sentry from "@sentry/browser";
import { isMyAppWKWebView } from "./isMyAppWKWebView";

// Type definitions for window extensions
declare global {
  interface Window {
    // // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    // Android?: any;
    // // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    // webkit?: any;
    // _androidPromise?: Record<string, { 
    //   resolve: (value: void | PromiseLike<void>) => void; 
    //   // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    //   reject: (reason?: any) => void; 
    // }>;
    AF?: {
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      logEvent: (eventName: string, eventValues: Record<string, any>) => Promise<any>;
    };
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    gtag?: (command: string, action: string, params?: Record<string, any>) => void;
  }
}

// Original signIn function with added web implementation
export async function signIn(data: {
  verificationId: string;
  verificationCode: string;
}) {
  if (window.Android) {
    if (!window._androidPromise) {
      window._androidPromise = {};
    }

    const promiseId = window.crypto.randomUUID();
    const returnPromise = new Promise<void>((resolve, reject) => {
      // biome-ignore lint/style/noNonNullAssertion: <explanation>
      window._androidPromise![promiseId] = { resolve, reject };
    });

    window.Android.signIn(
      promiseId,
      data.verificationId,
      data.verificationCode
    );

    return returnPromise;
  }

  if (isMyAppWKWebView()) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    return (window.webkit as any).messageHandlers.signIn.postMessage(data);
  }

  // The existing typing for verificationId seems incorrect, but all the iOS code seems to work, so don't want to mess with it
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    // const verificationId = (data.verificationId as any).verificationId as string;

  return signInWebBridge(data.verificationId, data.verificationCode);
}

async function signInWebBridge(verificationId: string, verificationCode: string): Promise<{ error: string | null }> {
  if (!verificationId || !verificationCode) {
      return { error: "Missing verificationId or verificationCode" };
  }
  
  try {
      const auth = getAuth();
      const credential = PhoneAuthProvider.credential(verificationId, verificationCode);
      // const authResult = 
      await signInWithCredential(auth, credential);
      
      // const additionalUserInfo = getAdditionalUserInfo(authResult);
      // const isNewUser: boolean | undefined = additionalUserInfo?.isNewUser;      
      
      // if (isNewUser !== undefined) {
      //     console.log("🆕 Is New User:", isNewUser);
      // } else {
      //     console.warn("⚠️ Could not determine if user is new (isNewUser is undefined)");
      // }
      
      // if (isNewUser) {
      //     console.log("📝 Logging new user registration with AppsFlyer...");
      //     AppsFlyerLib.logEvent(
      //         "af_complete_registration",
      //         {},
      //         // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      //         (error: Error | null, response: any) => {
      //             if (error) {
      //                 console.error("❌ AppsFlyer Registration Event Error:", error);
      //                 return;
      //             }
      //             console.log("✅ AppsFlyer Registration Event Success", response);
      //         }
      //     );
      // } else {
      //     console.log("ℹ️ Existing user sign-in - skipping AppsFlyer registration event");
      // }
      
      // console.log("✅ Sign-in process completed successfully");
      return { error: null };
  } catch (error: unknown) {
      const errorMessage = error instanceof Error ? error.message : "An unknown error occurred";
      // console.error("❌ Sign-in failed with error:", errorMessage);
      Sentry.captureException(error);
      return { error: errorMessage };
  }
}


